import { CssService } from "../service/css.service";
import { HTTPBase } from "./httpBase";




export class ChatPost extends HTTPBase {
    ask_message: string;
    override ask_type: string

    constructor(sessionid: string, ask_message: string, ask_type: string, agentId:string) {
        super()
        this.ask_message = ask_message
        this.ask_type = ask_type
        this.agent_id = agentId
        this.sessionid = sessionid
        this.source = "chat"

    }
}